// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-pages-index-page-index-brands-content-brands-mcoqf{display:grid;grid-gap:24px}.components-pages-index-page-index-brands-content-brands-mcoqf.components-pages-index-page-index-brands-content-desktop-bnftk{grid-template-columns:repeat(8,1fr)}.components-pages-index-page-index-brands-content-brands-mcoqf.components-pages-index-page-index-brands-content-mobile-ojteo{grid-template-columns:repeat(2,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brands": "components-pages-index-page-index-brands-content-brands-mcoqf",
	"desktop": "components-pages-index-page-index-brands-content-desktop-bnftk",
	"mobile": "components-pages-index-page-index-brands-content-mobile-ojteo"
};
module.exports = ___CSS_LOADER_EXPORT___;
